export const PRODUCT_BADGE_OPTIONS = [
  { value: "BEST_SELLER", label: "Best Seller" },
  { value: "TRENDING", label: "Trending" },
  { value: "NEW_ARRIVAL", label: "New Arrival" },
  { value: "LIMITED_STOCK", label: "Limited Stock" },
  { value: "HIGH_MARGIN", label: "High Margin" },
  { value: "TIKTOK_VIRAL", label: "TikTok Viral" },
];

export const LEGACY_BADGE_LABELS = {
  SOLD: "Sold",
  NEW: "New",
  INCOMMING: "Incomming",
  TICK_TOK_VERIFIED: "TikTok Verified",
};

export function getBadgeLabel(value) {
  const match = PRODUCT_BADGE_OPTIONS.find((opt) => opt.value === value);
  if (match) return match.label;
  return LEGACY_BADGE_LABELS[value] || value;
}
